import { bespokeTenants } from '@debbie/common/dist/bespoke/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { Site, validateEmail } from '@debbie/common/dist/index.js';
import * as usersAPI from '@debbie/cortex/dist/api/users.js';
import { IS_DEVELOP } from '@debbie/cortex/dist/config.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe, useRole } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { usersEntity } from '@debbie/cortex/dist/users/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { applyTargetValue } from '../../utils/index.js';
import Button from '../Button.js';
import Checkbox from '../Checkbox.js';
import { Col, Row } from '../Grid/index.js';
import { PhoneInput } from '../index.js';
import Input from '../Input.js';
import Messages from '../Messages/index.js';
import Panel from '../Panel.js';
import Select from '../Select.js';
import CreditorSelector from './CreditorSelector.js';
const CreateUserSettings = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const meRole = useRole();
    const tenant = useTenant();
    const [sendInvite, setSendInvite] = useState(true);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState(null);
    const [role, setRole] = useState(props.role ? props.role : '');
    const [creditors, setCreditors] = useState(props.creditorIds ? props.creditorIds : []);
    const [todoNotifications, setTodoNotifications] = useState(true);
    const [creditorMessageNotifications, setCreditorMessageNotifications] = useState(true);
    const [messages, setMessages] = useState([]);
    const [baseErrors, setErrors] = useState([]);
    const errors = baseErrors.concat([]);
    const onCreate = () => {
        if (role == '') {
            return;
        }
        const realRole = role === 'meeting-giver' ? 'caseworker' : role;
        const user = {
            email,
            phone: phone && phone.number != '' ? phone : null,
            username,
            firstName,
            lastName,
            sendInvite: role === 'client' ? sendInvite : true,
            role: realRole,
            details: role === 'meeting-giver'
                ? {
                    meetingAccountType: 'meeting_only',
                }
                : {},
            emailPreferences: {
                todoNotifications: role === 'meeting-giver' ? false : todoNotifications,
                ...(role === 'client' ? { creditorMessageNotifications } : {}),
            },
            tenant: {
                role: realRole,
                scopes: [],
            },
            creditors: creditors && role === 'client'
                ? creditors.map((id) => ({ id, scopes: [] }))
                : [],
        };
        usersAPI
            .create(user)
            .then((created) => {
            setMessages([lang.users.userCreated]);
            q.invalidate(keys.write.create(usersEntity));
            setFirstName('');
            setLastName('');
            setUsername('');
            setSendInvite(true);
            setEmail('');
            setPhone(null);
            setRole('');
            setCreditors([]);
            setTimeout(() => {
                setMessages([]);
            }, 10000);
            if (props.onCreate) {
                props.onCreate(created.id);
            }
        })
            .catch((err) => {
            setErrors([lang.users.updateFailed]);
            console.error(err);
            setMessages([]);
        });
    };
    return (React.createElement(Panel, { header: lang.users.userSettings },
        IS_DEVELOP ? (React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement(Messages, { messages: [lang.users.developEmailWarning], type: "warning" })))) : null,
        React.createElement(Row, null,
            errors.length > 0 ? (React.createElement(Col, { width: "12" },
                React.createElement(Messages, { messages: errors, type: "error" }))) : null,
            messages.length > 0 ? (React.createElement(Col, { width: "12" },
                React.createElement(Messages, { messages: messages, type: "success" }))) : null),
        React.createElement(Row, null, me ? (React.createElement(Col, { width: "12" },
            !props.role && meRole && meRole === 'admin' ? (React.createElement(Select, { onChange: (e) => {
                    setRole(e.currentTarget.value);
                }, value: role },
                React.createElement("option", { value: "" }, lang.users.selectRole),
                React.createElement("option", { value: "admin" }, lang.roles.admin),
                React.createElement("option", { value: "caseworker" }, lang.roles.caseworker),
                React.createElement("option", { value: "client" }, lang.roles.client),
                tenant?.id === bespokeTenants.mortangProd ? (React.createElement("option", { value: "meeting-giver" }, "M\u00F8degiver")) : null)) : null,
            React.createElement(Input, { placeholder: lang.users.firstName, value: firstName, onChange: applyTargetValue(setFirstName) }),
            React.createElement(Input, { placeholder: lang.users.lastName, value: lastName, onChange: applyTargetValue(setLastName) }),
            React.createElement(Input, { type: "email", placeholder: lang.users.email, value: email, onChange: (e) => {
                    setEmail(e.target.value);
                    setUsername(e.target.value);
                } }),
            React.createElement(PhoneInput, { phone: phone, placeholder: lang.users.phone, onChange: (phone) => {
                    setPhone(phone);
                }, noSaveOnValid: true }),
            !props.role && role === 'client' && site === Site.Caseworker ? (React.createElement(CreditorSelector, { selected: creditors, onSelect: (selected) => setCreditors(selected) })) : null,
            role != 'meeting-giver' && (React.createElement(Checkbox, { placeholder: lang.users.todoNotifications, checked: todoNotifications, onChange: (e) => {
                    setTodoNotifications(e.target.checked);
                } })),
            role === 'client' && (React.createElement(Checkbox, { placeholder: lang.users.creditorMessageNotifications, checked: creditorMessageNotifications, onChange: (e) => {
                    setCreditorMessageNotifications(e.target.checked);
                } })),
            role === 'client' && site === Site.Caseworker ? (React.createElement(Checkbox, { placeholder: lang.users.sendInvite, checked: sendInvite, onChange: (e) => {
                    setSendInvite(e.target.checked);
                } })) : null,
            React.createElement(Button, { onClick: onCreate, block: true, disabled: firstName === '' ||
                    lastName === '' ||
                    !validateEmail(email) ||
                    role === '' ||
                    (role === 'client' && creditors.length === 0) }, sendInvite ? lang.users.inviteUser : lang.users.createUser))) : null)));
};
export default CreateUserSettings;
//# sourceMappingURL=CreateUserSettings.js.map